import React, { useCallback, useEffect, useState } from 'react';
import { MAP_EVENTS } from '../constants';
const EMPTY_INITIAL_LAYER_STATE = {};
export default function DatasourceLayer({
  map,
  name,
  layer,
  setSource
}) {
  const [layerData, setLayerData] = useState(layer.initialLayerData || EMPTY_INITIAL_LAYER_STATE);
  const [layerExtent, setLayerExtent] = useState(() => map.getExtent());

  // handle extent + layer data changes
  useEffect(() => {
    const extentListener = map.addEventListener(MAP_EVENTS.extentChange, () => {
      setLayerExtent(map.getExtent());
    });
    const dataListener = map.addEventListener(MAP_EVENTS.layerData, e => {
      if (e.layerName !== name) {
        return;
      }
      setLayerData(oldData => {
        if (typeof oldData === 'object' && typeof e.layerData === 'object') {
          return {
            ...oldData,
            ...e.layerData
          };
        }
        return e.layerData;
      });
    });

    // eslint-disable-next-line consistent-return
    return () => {
      map.removeEventListener(MAP_EVENTS.extentChange, extentListener);
      map.removeEventListener(MAP_EVENTS.layerData, dataListener);
    };
  }, [map, setLayerExtent, setLayerData]);
  const wrappedSetLayer = useCallback(newData => {
    if (!map) {
      return;
    }
    // TODO: not sure, but if we need to handle function
    //  based modification, we can do it here
    map.setLayerData(name, newData);
  }, [map]);
  const DataSource = layer.source;
  return /*#__PURE__*/React.createElement(DataSource, {
    extent: layerExtent,
    zoom: map.getZoom(),
    layerData: layerData,
    setLayerData: wrappedSetLayer,
    setSource: setSource
  });
}